import { Injectable } from "@angular/core";
import { ECopyShowsResult, ShowRepository } from "../../domain/show-repository";
import { Show } from "../../domain/show";
import moment from "moment";
import { ToastrService } from "ngx-toastr";
import { NgxSmartModalService } from "ngx-smart-modal";
import { UI } from "../ui.service";
import { showWarningOnce } from "tslint/lib/error";
import { UserService } from "../../domain/user-service";
import { Channel } from "../../domain/channel";

@Injectable()
export class CopyShowsViewModel {
  private _copyFromShow: Show;
  private _copyToShow: Show;
  private _clipboard: CopyShowClipboardItem = null;

  constructor(
    private _showRepository: ShowRepository,
    private _ui: UI,
    private _toastr: ToastrService,
    private _modalService: NgxSmartModalService,
    private _userService: UserService,
  ) {}
  /*public copyFromActionAvailable(targetShow: Show): boolean {
    return true;
  }*/
  public get readyToPaste(): boolean {
    return !!this._clipboard;
  }

  public get isMultiplySelection(): boolean {
    //console.log('copy-shpws-vm->isMultiplySelection->', this.readyToCopy && this._copyFromShow.id !== this._copyToShow.id);
    return this.readyToCopy && this._copyFromShow.id !== this._copyToShow.id;
  }

  public get readyToCopy(): boolean {
    return this.copyToActionAvailable(this._copyToShow);
  }

  private copyToActionAvailable(targetShow: Show): boolean {
    return (
      !!this._copyFromShow &&
      targetShow.channelId === this._copyFromShow.channelId &&
      this._copyFromShow.startTime.isSameOrBefore(targetShow.startTime)
    );
  }

  private setCopyFromShow(show: Show) {
    if (
      !!this._copyToShow &&
      (show.channelId !== show.channelId ||
        this._copyToShow.startTime.isSameOrBefore(show.startTime))
    ) {
      this._copyToShow = null;
    }
    this._copyFromShow = show;
  }

  private setCopyToShow(show: Show) {
    //console.log('copy-shows-vm->setCopyToShow', show, this._copyFromShow, this._copyToShow);
    /*if (this.copyToActionAvailable(show)) {
      this._copyToShow = show;
    }*/
    if (
      !!this._copyFromShow &&
      show.channelId === this._copyFromShow.channelId
    ) {
      this._copyToShow = show;
    }
  }

  public copySelectedShows(allShows: any[]): void {
    this._clipboard = new CopyShowClipboardItem(
      this._copyFromShow.clone(),
      this._copyToShow.clone(),
    );
    allShows.forEach((s) => {
      s.selected = false;
      s.firstSelected = false;
    });
    this._toastr.success("Shows have been copied!");
  }

  public showClickedEventHandler(
    show: Show | any,
    allShows: any[],
    event: MouseEvent,
  ) {
    //console.log('copy-shows-view-model->showClickedEventHandler-> start', event);
    const existingSelectedShow = allShows.find((s) => s.firstSelected) as Show;
    allShows.forEach((s) => (s.selected = false));

    if (event.shiftKey && existingSelectedShow) {
      const fromShowIndex = Math.min(
        allShows.indexOf(existingSelectedShow),
        allShows.indexOf(show),
      );
      const toShowIndex = Math.max(
        allShows.indexOf(existingSelectedShow),
        allShows.indexOf(show),
      );
      allShows
        .slice(fromShowIndex, toShowIndex + 1)
        .forEach((s) => ((s as any).selected = true));
      this.setCopyFromShow(allShows[fromShowIndex]);
      this.setCopyToShow(allShows[toShowIndex]);
    } else {
      if (!existingSelectedShow || existingSelectedShow.id !== show.id) {
        show.selected = true;
        allShows.forEach((s) => (s.firstSelected = false));
        show.firstSelected = true;
      }
      if (!!existingSelectedShow && existingSelectedShow.id === show.id) {
        show.firstSelected = false;
      }

      this.setCopyFromShow(show);
      this.setCopyToShow(show);
    }
    console.log(
      `copy-shows-view-model->showClickedEventHandler-> selected=${show.selected}, firstSelected=${show.firstSelected}, existingSelectedShow=`,
      existingSelectedShow,
    );
  }

  public contextMenuLoopFillItemClicked(
    selectedShow: Show,
    targetChannel: Channel,
    isBlock: boolean,
  ): void {
    this._modalService.setModalData(
      {
        targetStartTimeBefore: selectedShow.startTime,
        targetStartTimeAfter: selectedShow.endTime,
        targetChannel: targetChannel,
        isBlock: isBlock,
      },
      "loopFillShowsPopupModal",
      true,
    );
    this._modalService.getModal("loopFillShowsPopupModal").open();
  }

  public multiplySelectedEndTime(
    multiplier: number,
    pasteStartTime: moment.Moment,
  ): moment.Moment {
    let currentEndTime = this._copyToShow.endTime;
    let currentStartTime = this._copyFromShow.startTime;
    if (this._clipboard) {
      currentEndTime = this._clipboard.copyShowTo.endTime;
      currentStartTime = this._clipboard.copyShowFrom.startTime;
    }
    const selectionDuration =
      currentEndTime.diff(currentStartTime, "milliseconds") * multiplier;
    return pasteStartTime.clone().add(selectionDuration);
  }
  public async pasteUntilNextItem(
    startTime: moment.Moment,
    targetChannel: Channel,
    isBlock: boolean,
    partial?: boolean,
  ): Promise<string | void> {
    try {
      var nextItem = await this._showRepository.getNextShow(
        targetChannel.id,
        startTime,
      );
      if (nextItem instanceof Error) {
        return Promise.reject(nextItem.message);
      }
      return this.paste(
        startTime,
        targetChannel,
        isBlock,
        nextItem.startTime,
        partial,
      );
    } catch (err) {
      console.log("copy-shows-view-model->pasteUntilNextItem->error: ", err);
    }
  }
  public paste(
    startTime: moment.Moment,
    targetChannel: Channel,
    isBlock: boolean,
    repeatUntil?: moment.Moment,
    copyPartial?: boolean,
  ): Promise<string | void> {
    copyPartial = copyPartial || false;
    if (repeatUntil && repeatUntil.isBefore(startTime)) {
      this._toastr.error(
        `Loop Until Date should be bigger than ${startTime.format("YYYY-MM-DD HH:mm")}`,
      );
      return Promise.resolve();
    }
    return CopyShowsViewModel.showConfirmSecondaryEventSignalSettingsPopup(
      this._ui,
      this._showRepository,
      targetChannel,
      isBlock,
      this._clipboard.copyShowFrom,
      this._clipboard.copyShowTo,
      startTime,
      repeatUntil,
      copyPartial,
    )
      .then(() => {
        this.clearClipboard();
      })
      .catch((err) => {
        console.log("copy-shows-view-model->error", err);
        if (err) {
          if (err.message) {
            return Promise.reject(err.message);
          }
          this._ui.notify(this._ui.EVENTS.ShowAlert, {
            title: "Copy Field",
            message:
              "Can't move the number of days defined for this channel. Please contact support.",
          });
        }
      });
  }

  public static async showConfirmSecondaryEventSignalSettingsPopup(
    ui: UI,
    showRepository: ShowRepository,
    channel: Channel,
    isBlock: boolean,
    showFrom: Show,
    showTo: Show,
    startTime: moment.Moment,
    repeatUntil?: moment.Moment,
    copyPartial?: boolean,
  ) {
    const copyShowsResult = await showRepository.copyShowsWithSecondaryEvents(
      channel.id,
      showFrom,
      showTo,
      startTime,
      isBlock,
      true,
      !isBlock,
      repeatUntil,
      copyPartial,
    );
    if (copyShowsResult === ECopyShowsResult.OverlapShowsForbidden) {
      return Promise.reject(new Error("Can't overlap future shows"));
    }
    if (copyShowsResult === ECopyShowsResult.OverlapAnchoredShows) {
      return Promise.reject(new Error("Can't push forward anchored shows"));
    }
    if (copyShowsResult === ECopyShowsResult.SecondaryEventCommandsMissing) {
      ui.notify(ui.EVENTS.ShowConfirm, {
        title: "No CUETONE/DTMF found in channel settings.",
        message: `Would you like to add it to the channel settings?`,
        buttons: [
          {
            title: "Yes",
            callback: async () => {
              await showRepository.copyShowsWithSecondaryEvents(
                channel.id,
                showFrom,
                showTo,
                startTime,
                true,
                false,
                !isBlock,
                repeatUntil,
                copyPartial,
              );
            },
          },
          {
            title: "No",
            callback: async () => {
              await showRepository.copyShowsWithSecondaryEvents(
                channel.id,
                showFrom,
                showTo,
                startTime,
                false,
                false,
                !isBlock,
                repeatUntil,
                copyPartial,
              );
            },
          },
          {
            title: "Cancel",
            callback: () => {},
          },
        ],
      });
    }
  }

  private clearClipboard(): void {
    this._copyToShow = null;
    this._copyFromShow = null;
    this._clipboard = null;
  }
}
class CopyShowClipboardItem {
  constructor(
    public copyShowFrom: Show,
    public copyShowTo: Show,
  ) {}
}
